import * as types from '../constants/game';
import { apiAction } from './api';

export const loadGame = (game) => ({
  type: types.GAME_LOAD,
  game,
});

export const toggleGameModal = () => ({
  type: types.GAME_TOGGLE_MODAL,
});

export const setGameView = (view) => ({
  type: types.GAME_SET_VIEW,
  view,
});

export const levelUp = () => (dispatch, getState) => {
  if (getState().game.canLevelUp) {
    dispatch(
      apiAction(
        [
          types.GAME_LEVEL_UP_START,
          types.GAME_LEVEL_UP_SUCCESS,
          types.GAME_LEVEL_UP_FAILURE,
        ],
        (api) => api.levelUp()
      )
    );
  }
};

export const loadGameHistory = () => (dispatch, getState) => {
  dispatch(
    apiAction(
      [
        types.GAME_LOAD_HISTORY_START,
        types.GAME_LOAD_HISTORY_SUCCESS,
        types.GAME_LOAD_HISTORY_FAILURE,
      ],
      (api) => api.getGameHistory()
    )
  );
};

export const loadGameRanking = () => (dispatch, getState) => {
  dispatch(
    apiAction(
      [
        types.GAME_LOAD_RANKING_START,
        types.GAME_LOAD_RANKING_SUCCESS,
        types.GAME_LOAD_RANKING_FAILURE,
      ],
      (api) => api.getGameRanking()
    )
  );
};

export const changeGameLevel = (levelid) => (dispatch, getState) => {
  if (getState().game.canChangeLevels) {
    dispatch(
      apiAction(
        [
          types.GAME_CHANGE_LEVEL_START,
          types.GAME_CHANGE_LEVEL_SUCCESS,
          types.GAME_CHANGE_LEVEL_FAILURE,
        ],
        (api) => api.changeGameLevel(levelid)
      )
    );
  }
};
